export abstract class SBaseDisplay {
  abstract toShortString(parameter?: string): string;
}
